import { apiClient } from '../../config/axios.config'; // Adjust the import path as necessary
import { BASE_URL, BASE_EMPLOYEE_URL, CODE_LIST_URL } from '../apiConfig';

// Fetch Employee Details
const fetchEmployeeDetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EMPLOYEE_URL}/all-details`,
    payload,
  );
  return response.result;
};

// Fetch Employee Profile Picture
const fetchEmployeeProfilePicture = async payload => {
  try {
    const response = await apiClient.create(
      `${BASE_URL}${BASE_EMPLOYEE_URL}/get-picture`,
      payload,
      { responseType: 'blob', suppressToast: true },
    );

    return URL.createObjectURL(new Blob([response]));
  } catch (err) {
    return null;
  }
};

// Fetch Employee Delegated Approvers
const fetchEmployeeDelegatedApprovers = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EMPLOYEE_URL}/get-delegate`,
    payload,
  );
  return response.delegateApprovalDetails;
};

// Apply for New Delegate Approver
const applyNewDelegateApprover = async payload => {
  const response = await apiClient.create('', payload);
  return response.data;
};

// Fetch Document Details
const fetchDocumentDetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EMPLOYEE_URL}/get-document`,
    payload,
    { responseType: 'blob' },
  );
  return response;
};

// Update Delegate Approver
const updateDelegateApprover = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EMPLOYEE_URL}/update-delegate`,
    payload,
    { suppressToast: true },
  );
  return response.data;
};

// Fetch Employee Details
const fetchEmployeeOwnDetails = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_EMPLOYEE_URL}/get-details`,
  );
  return response.length === 1 ? response[0] : null;
};

// Fetch employee data (Own)
const fetchEmployeeData = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_EMPLOYEE_URL}/get-data`,
  );
  return response;
};

// Fetch employees
const fetchEmployees = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EMPLOYEE_URL}/get-employees`,
    payload,
  );
  return response;
};

const fetchEmployeeList = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EMPLOYEE_URL}/get-employee-list`,
    payload,
  );
  return response;
};

const fetchEmployeeSearch = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EMPLOYEE_URL}/employee-search`,
    payload,
  );
  return response;
};

const fetchEmployeeMasterSearch = async payload => {
  const requestPayload = {
    ...payload,
    prefixText:
      payload?.prefixText ??
      payload?.text ??
      (typeof payload === 'string' ? payload : ''),
    companyCode: payload?.companyCode || '',
  };
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EMPLOYEE_URL}/employee-master-search`,
    requestPayload,
  );
  return response;
};

const updateContactDetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EMPLOYEE_URL}/update-address`,
    payload,
  );
  return response.data;
};

const employeeCodeList = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EMPLOYEE_URL}/get-codeList`,
    payload,
  );
  return response.result;
};

const fetchEmployeeCountryCodeList = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${CODE_LIST_URL}`,
    payload,
  );
  return response.result;
};

const fetchEmployeeFacilities = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EMPLOYEE_URL}/get-facilities`,
    payload,
  );
  return response; // returns array of employeefacilities
};

const deleteEmployee = async payload => {
  const response = await apiClient.delete(
    `${BASE_URL}${BASE_EMPLOYEE_URL}/delete-employee`,
    { data: payload },
  );
  return response;
};

export {
  fetchEmployeeDetails,
  fetchEmployeeDelegatedApprovers,
  applyNewDelegateApprover,
  fetchEmployeeProfilePicture,
  fetchDocumentDetails,
  updateDelegateApprover,
  fetchEmployeeOwnDetails,
  fetchEmployeeData,
  fetchEmployees,
  fetchEmployeeList,
  fetchEmployeeSearch,
  fetchEmployeeMasterSearch,
  updateContactDetails,
  employeeCodeList,
  fetchEmployeeCountryCodeList,
  fetchEmployeeFacilities,
  deleteEmployee,
};
